import {Injectable} from '@angular/core';
import {Tenant} from '../interfaces/tenant';
import {HttpClient} from '@angular/common/http';
import {GeneralService} from './general.service';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

/**
 * A service for tenant management.
 */
@Injectable({
  providedIn: SuperuserServiceModule
})
export class TenantService extends GeneralService<Tenant> {

  constructor(http: HttpClient, private uiSettingsService: UiSettingsService) {
    super(http, uiSettingsService, 'tenants', 'tenant');
  }
}
